import { Wallet } from 'lucide-react'
import KassaAccountCard from '@/components/kassa/KassaAccountCard'
import KassaVouchersCard from '@/components/kassa/KassaVouchersCard'
import RaffleUserWidget from '@/components/raffle/RaffleUserWidget'
import PageHeader from '@/components/PageHeader'

/* Persoonlijke kassa-hub — saldo, openstaande rekening en vouchers.
   Zat vroeger onder ProfilePage; verhuisd omdat je publieke profiel
   niet de plek is voor rekening-info. */
export default function KassaMePage() {
  return (
    <div className="max-w-3xl mx-auto p-6 space-y-6">
      <PageHeader
        title="Mijn kassa"
        subtitle="Saldo, openstaande rekening en vouchers"
        icon={Wallet}
      />
      <div className="grid gap-4 md:grid-cols-2">
        <KassaAccountCard />
        <KassaVouchersCard />
      </div>
      <RaffleUserWidget />
    </div>
  )
}
